// Helper functions for creating and managing category tag HTML elements
// Maintains exact functionality while using modern JavaScript functional patterns

/**
 * Creates a category tag element with remove functionality
 * @param {string} categoryName - The name of the category
 * @return {jQuery} - jQuery element of the created tag
 */
export const createCategoryTag = (categoryName) => {
  const categoryTag = $(`
    <div class="temp-category-filter" role="listitem">
      <div class="temp-category-tag filter-tag" data-category="${categoryName}" title="${categoryName}">
        <span class="tag-label">${categoryName}</span>
        <button type="button"
                class="filter-tag-close remove-temp-category"
                aria-label="Remove category"
                title="Remove">
          <i class="fal fa-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  `);

  // Removal handler (button click)
  categoryTag.on("click", ".remove-temp-category, .filter-tag-close", function (e) {
    e.preventDefault();
    e.stopPropagation();
    removeCategoryTag($(this), categoryName);
  });

  // Hover effects are now handled by CSS

  return categoryTag;
};

/**
 * Handles category tag removal
 * @param {jQuery} removeButton - The remove button that was clicked
 * @param {string} categoryName - The category name to remove
 */
export const removeCategoryTag = (removeButton, categoryName) => {
  try {
    const tempInput = $("#temp_categories_input");
    const selectedCategoriesDiv = $(".selected-categories-container");

    // Update hidden input value
    let currentValue = tempInput.val();
    let currentCategories = currentValue ? currentValue.split("|") : [];
    let updatedCategories = currentCategories.filter(
      (cat) => cat !== categoryName,
    );

    updateTempInput(updatedCategories);

    // Remove visual tag - try multiple selectors to ensure removal
    const tagToRemove = removeButton.closest(".temp-category-filter");
    if (tagToRemove.length === 0) {
      // Fallback: find by data-category attribute
      $(`.temp-category-tag[data-category="${categoryName}"]`)
        .closest(".temp-category-filter")
        .remove();
    } else {
      tagToRemove.remove();
    }

    // Hide container if no categories left
    if (updatedCategories.length === 0) {
      toggleCategoriesContainer(false);
    }

  } catch (error) {
    console.error("Error removing category:", error);
  }
};

/**
 * Updates the temporary categories input value
 * @param {Array} categories - Array of category names
 */
export const updateTempInput = (categories) => {
  const tempInput = $("#temp_categories_input");
  tempInput.val(categories.join("|"));
};

/**
 * Shows or hides the selected categories container
 * @param {boolean} show - Whether to show the container
 */
export const toggleCategoriesContainer = (show) => {
  const selectedCategoriesDiv = $(".selected-categories-container");

  if (show) {
    selectedCategoriesDiv.show();
  } else {
    selectedCategoriesDiv.hide();
  }
};

/**
 * Gets current selected categories from temp input
 * @return {Array} - Array of selected category names
 */
export const getCurrentCategories = () => {
  const tempInput = $("#temp_categories_input");
  const tempValue = tempInput.val();

  if (tempValue && tempValue.length > 0) {
    return tempValue.includes("|") ? tempValue.split("|") : [tempValue];
  }

  return [];
};

/**
 * Clears all selected categories
 */
export const clearAllCategories = () => {
  try {
    const tempInput = $("#temp_categories_input");
    const tempContainer = $(".temp-categories-container");
    const selectedCategoriesDiv = $(".selected-categories-container");

    // Clear all
    if (tempInput.length > 0) tempInput.val("");
    if (tempContainer.length > 0) tempContainer.empty();
    if (selectedCategoriesDiv.length > 0) selectedCategoriesDiv.hide();

  } catch (error) {
    console.error("Error clearing categories:", error);
  }
};

